module.exports = __webpack_public_path__ + "img/6.e98fdf4a.jpg";